import { render, staticRenderFns } from "./SsePage.vue?vue&type=template&id=20bffa0f&"
import script from "./SsePage.vue?vue&type=script&lang=js&"
export * from "./SsePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports